/* eslint-disable @next/next/no-img-element */
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogDescription,
  DialogTitle,
} from "../../../../shadcn/components/ui/dialog";
import CrossIcon from "../../../../icons/CrossIcon";
import ProfileIconSvg from "../../../../icons/ProfileIconSvg";
import { useSelector } from "react-redux";
import ProfileImageUploader from "./ProfileImageUploader";
import { useSmoothScroll } from "../../../../hoc";
import { getWatermarkedImgixUrl } from "services";

interface ProfileCardProps {
  promember?: Boolean;
}

export const ProfileCard = ({ promember }: ProfileCardProps) => {
  const userProfile = useSelector((state: any) => {
    return state.auth?.user?.profile;
  });
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const userAttributes = useSelector((state: any) => {
    const attributes = state.auth?.user?.attributes;
    const mobile = attributes?.find(
      (attr: any) => attr.type === "mobile_number",
    );
    const email = attributes?.find((attr: any) => attr.type === "email");
    return { email: email?.value, mobile: mobile?.value };
  });

  const userUuid = useSelector((state: any) => {
    return state.auth?.user?.uuid;
  });

  const [imageModal, setImageModal] = useState(false);

  const { scrollToId } = useSmoothScroll();
  return (
    <div
      id="onboarding-extra-details"
      className="w-full mt-11 lg:mt-[68px]  px-customPaddingMobile lg:pl-customPadding lg:pr-[148px] 2xl:w-[1192px] 2xl:mx-auto  2xl:px-0 "
    >
      <div className="bg-brand-lightBlue bg-[url('/wave2.png')]  bg-no-repeat bg-[position:calc(100%+20px)_0px] px-4 lg:px-[50px] mid:px-[100px] lg:pr-20 lg:flex justify-between relative pb-5 pt-6 lg:pt-[67px] lg:pb-[63px] clip-path-bottomRightFooterMobile lg:clip-path-bottomRightTool">
        {promember && (
          <div className="absolute font-openSans text-mobile-body-xsm lg:text-web-body-lg font-semibold  text-brand-bgWhite leading-4 lg:leading-6 bg-brand-orange pr-10 lg:pr-[70px] pl-5  lg:pl-10  lg:py-1.5 top-0 left-0 clip-path-topRightFourSided">
            Pro Member
          </div>
        )}

        <div className="w-full lg:w-[466px] justify-between items-center lg:flex">
          <Dialog open={imageModal} onOpenChange={setImageModal}>
            <DialogTrigger>
              {userProfile?.profile_picture ? (
                <img
                  className="h-[94px] rounded-full w-[94px] lg:w-[183px] lg:h-[183px] cursor-pointer hover:opacity-80 transition-opacity"
                  src={getWatermarkedImgixUrl(
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${userProfile?.profile_picture}`,
                  )}
                  alt=""
                />
              ) : (
                <ProfileIconSvg className="h-[94px] w-[94px] lg:w-[183px] lg:h-[183px] cursor-pointer hover:opacity-80 transition-opacity" />
              )}
            </DialogTrigger>
            <DialogContent
              closeIcon={
                <CrossIcon className="h-4 w-4 lg:h-6 lg:w-6 lg:mt-2  lg:mr-6" />
              }
              className="min-w-full md:max-w-[774px] md:min-w-0 lg:max-w-[847px] lg:h-[535px] pt-[100px] pb-[38px] px-4 lg:pt-[71px] lg:pb-[81px] lg:pl-[102px] lg:pr-[131px]"
            >
              <DialogTitle className="hidden"></DialogTitle>

              <DialogDescription className="hidden"> </DialogDescription>
              <ProfileImageUploader
                userProfile={userProfile}
                userUuid={userUuid}
                onSave={() => {
                  setImageModal(false);
                  scrollToId("onboarding-form-top");
                }}
              />
            </DialogContent>
          </Dialog>

          {/* User Details */}
          <div className="ml-3 lg:ml-0 ">
            <p className="font-openSans mt-[18px] capitalize lg:mt-0 text-mobile-h2 lg:text-[38px] font-normal text-brand-bgBlack leading-[38px] lg:leading-[52px]">
              {onboardingData?.name ? onboardingData?.name : "Profile Details"}
            </p>
            <p className="mt-2.5 font-openSans text-mobile-body-sm lg:text-web-subheading font-normal text-brand-textLightGrey leading-4 lg:leading-6">
              {userAttributes.email
                ? userAttributes.email
                : userAttributes.mobile
                ? userAttributes.mobile
                : ""}
            </p>
          </div>
        </div>

        <div className="mt-7 lg:mt-auto lg:mb-[30px] ml-3 lg:ml-0">
          <button
            className="h-9 w-[136px] lg:h-fit lg:w-[160px] mid:w-auto rounded-md mid:px-[54px] lg:py-[18px] bg-brand-bgBlack font-openSans font-semibold text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-4 text-white"
            onClick={() => scrollToId("onboarding-preference-details")}
          >
            Set preferences
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
